// we want any here because the component just stringifies the remaining props of any type

export function debugLog(...args: any[]) {
  import.meta.env.DEV && console.log(args)
}
